import React, { useState, useEffect } from 'react';

function useWindowWidth() {
  const [width, setWidth] = useState(window.innerWidth);
  useEffect(() => {
    const onResize = () => setWidth(window.innerWidth);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);
  return width;
}

const C = {
  bg: '#FFFFFF',
  text: '#1A1A1A',
  accent: '#00A896',
  cta: '#FF8C00',
  bubble: '#F5F5F5',
  border: '#E8E8E8',
  error: '#E53E3E',
  headerBg: 'rgba(255,255,255,0.97)',
};

function Header() {
  const isPC = useWindowWidth() > 768;
  return (
    <header style={{
      position: 'sticky',
      top: 0,
      zIndex: 1000,
      background: C.headerBg,
      borderBottom: '1px solid #000000',
    }}>
      <div style={{
        maxWidth: 480,
        margin: '0 auto',
        padding: '14px 20px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}>
        <a href="/lp02" style={{ textDecoration: 'none' }}>
          <img
            src="/images/nuntlogo.png"
            alt="Nunt"
            style={{ height: isPC ? 64 : 52, width: 'auto' }}
          />
        </a>
      </div>
    </header>
  );
}

function Field({ label, sublabel, error, children }) {
  return (
    <div style={{ marginBottom: 24 }}>
      <label style={{ display: 'block', marginBottom: 6 }}>
        <span style={{ fontSize: 15, fontWeight: 700, color: C.text }}>
          {label}
        </span>
        {sublabel && (
          <span style={{ display: 'block', fontSize: 12, color: '#888', marginTop: 2 }}>
            {sublabel}
          </span>
        )}
      </label>
      {children}
      {error && (
        <p style={{ fontSize: 12, color: C.error, marginTop: 6 }}>{error}</p>
      )}
    </div>
  );
}

function inputStyle(focused, hasError) {
  return {
    width: '100%',
    padding: '12px 14px',
    fontSize: 15,
    color: C.text,
    background: '#FFFFFF',
    border: `1px solid ${hasError ? C.error : focused ? C.accent : C.border}`,
    borderRadius: 8,
    outline: 'none',
    boxSizing: 'border-box',
    transition: 'border-color 0.2s',
    fontFamily: "'Noto Sans Thai', 'Noto Sans JP', sans-serif",
  };
}

function Input({ type = 'text', value, onChange, placeholder, hasError }) {
  const [focused, setFocused] = useState(false);
  return (
    <input
      type={type}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      style={inputStyle(focused, hasError)}
      onFocus={() => setFocused(true)}
      onBlur={() => setFocused(false)}
    />
  );
}

const FIELDS = [
  { key: 'realName',  label: 'ชื่อจริง',   sublabel: null,                          type: 'text' },
  { key: 'stageName', label: 'ชื่อในวงการ', sublabel: null,                          type: 'text' },
  { key: 'email',     label: 'อีเมล',       sublabel: null,                          type: 'email' },
  { key: 'lineId',    label: 'LINE ID',     sublabel: null,                          type: 'text', optional: true },
  { key: 'snsUrl',    label: 'SNS URL',     sublabel: 'Instagram / TikTok / X etc.', type: 'url', placeholder: 'https://' },
];

export default function Apply() {
  const [values, setValues] = useState({
    realName: '', stageName: '', email: '', lineId: '', snsUrl: '',
  });
  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);

  const validate = () => {
    const newErrors = {};
    FIELDS.forEach(({ key, type, optional }) => {
      const val = values[key].trim();
      if (!val && optional) return;
      if (!val) {
        newErrors[key] = 'กรุณากรอกข้อมูล';
      } else if (type === 'email' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val)) {
        newErrors[key] = 'กรุณากรอกอีเมลให้ถูกต้อง';
      } else if (type === 'url' && !/^https?:\/\/.+/.test(val)) {
        newErrors[key] = 'กรุณากรอก URL ที่เริ่มต้นด้วย https://';
      }
    });
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = validate();
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }
    setSubmitting(true);
    try {
      const res = await fetch('https://formspree.io/f/xnjlwakb', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          '本名 / ชื่อจริง': values.realName,
          '活動名 / ชื่อในวงการ': values.stageName,
          'メール / อีเมล': values.email,
          'LINE ID': values.lineId,
          'SNS URL': values.snsUrl,
        }),
      });
      if (res.ok) {
        window.location.href = '/lp02/apply/thanks';
      } else {
        setErrors({ _form: 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง' });
      }
    } catch {
      setErrors({ _form: 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง' });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div style={{ background: C.bg, minHeight: '100vh', fontFamily: "'Noto Sans Thai', 'Noto Sans JP', sans-serif" }}>
      <Header />
      <main style={{ maxWidth: 480, margin: '0 auto', padding: '40px 20px 60px' }}>
        <div style={{ marginBottom: 36 }}>
          <h1 style={{ fontSize: 22, fontWeight: 700, color: C.text, lineHeight: 1.6, marginBottom: 8 }}>
            เริ่มสร้าง Passive Income
          </h1>
          <p style={{ fontSize: 14, color: '#888', lineHeight: 1.8 }}>
            แบบฟอร์มสมัคร
          </p>
          <div style={{ width: 32, height: 2, background: C.accent, marginTop: 12, borderRadius: 1 }} />
        </div>

        <form onSubmit={handleSubmit} noValidate>
          {FIELDS.map(({ key, label, sublabel, type, placeholder }) => (
            <Field key={key} label={label} sublabel={sublabel} error={errors[key]}>
              <Input
                type={type}
                value={values[key]}
                onChange={(e) => {
                  setValues((v) => ({ ...v, [key]: e.target.value }));
                  setErrors((er) => ({ ...er, [key]: undefined }));
                }}
                placeholder={placeholder}
                hasError={!!errors[key]}
              />
            </Field>
          ))}

          {errors._form && (
            <p style={{ color: C.error, fontSize: 13, marginBottom: 16 }}>{errors._form}</p>
          )}

          <button
            type="submit"
            disabled={submitting}
            style={{
              width: '100%',
              background: submitting ? '#ccc' : C.cta,
              color: '#FFFFFF',
              fontSize: 16,
              fontWeight: 700,
              padding: '18px 0',
              borderRadius: 8,
              border: 'none',
              cursor: submitting ? 'not-allowed' : 'pointer',
              letterSpacing: '0.05em',
              fontFamily: "'Noto Sans Thai', 'Noto Sans JP', sans-serif",
            }}
          >
            {submitting ? 'กำลังส่ง...' : 'เริ่มใช้งานฟรี'}
          </button>
        </form>
      </main>
    </div>
  );
}
